"use client"

// Sonner-backed shim — replaces @radix-ui/react-toast.
// API is identical to the original shadcn useToast so all callers work unchanged.
import { toast as sonnerToast } from 'sonner';

interface ToastOptions {
  title?: string;
  description?: string;
  variant?: 'default' | 'destructive';
}

function toast({ title, description, variant }: ToastOptions) {
  const message = title ?? description ?? '';
  const opts = title && description ? { description } : undefined;
  if (variant === 'destructive') {
    sonnerToast.error(message, opts);
  } else {
    sonnerToast(message, opts);
  }
}

function useToast() {
  return { toast, toasts: [] };
}

export { useToast, toast };
